export function capture(event, properties = {}) {
  try {
    if (window.posthog) {
      window.posthog.capture(event, properties);
    }
  } catch {}
}

export function ctaClick(label, location) {
  capture("cta_click", { label, location });
}

export function scrollDepth(depth) {
  capture("scroll_depth", { depth });
}